import { createSelector } from 'reselect';

const piqoSelect = (state) => state.profile.participationInQesOrganizations;

export const selectPIQO = createSelector(piqoSelect, (data) => data);
